import React, {useRef, useState} from "react";
import {Link} from "react-router-dom";
import {ArrowLeft, Download} from "react-bootstrap-icons";
import TextAreaField from "../../../componennts/textarea";

import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles

import HtmlToDocx from "@turbodocx/html-to-docx";

function Fact_Profile_V1(props) {

    const [title, setTitle] = useState();

    const [inputValue, setInputValue] = useState('');
    const [keyWords, setKeyWords] = useState([]);

    const [shortContent, setShortContent] = useState();

    const quillRef = useRef(null); // Ref to access Quill instance
    const [content, setContent] = useState();

    const handleContentChange = (value, delta, source, editor) => {
        setContent(value);
    };

    // CONFIG
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['image', 'blockquote'],

            [{'header': 1}, {'header': 2}],               // custom button values
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent

            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
            [{'header': [1, 2, 3, 4, 5, false]}],

            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
            [{'font': []}],
            [{'align': []}],

            ['clean'],
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false
        }
    };

    const [summary, setSummary] = useState();

    const handleKeyDown = (event) => {
        // 1. Check if the pressed key is "Enter"
        if (event.key === 'Enter') {
            // 2. Prevent form submission or accidental reloads
            event.preventDefault();

            // 3. Avoid adding empty spaces or blank strings
            if (inputValue.trim() === '') return;

            // 4. Update the state array using the spread operator
            setKeyWords((prevItems) => [...prevItems, inputValue.trim()]);

            // 5. Clear the text input box
            setInputValue('');
        }
    };

    const handleDeleteTag = (indexToRemove) => {
        setKeyWords(prevItems => prevItems.filter((_, index) => index !== indexToRemove));
    }

    const fields = [
        {
            title: "Ключові слова",
            field: <div className={'d-flex'}>
                <div className="col-md-6 p-2">
                    <input
                        type="mail"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Введіть ключове слово та натисніть Enter..."
                        className={'w-100 border-0 p-1 border-bottom'}
                    />
                </div>
                <div className="col-md-6 p-2 d-flex flex-wrap">
                    {keyWords?.map((item, index) => (
                        <small key={index} className={'p-1 mx-1 my-1 bg-light-subtle rounded border hover-bg-danger'}
                               onClick={() => handleDeleteTag(index)}>{item}</small>
                    ))}
                </div>
            </div>
        },
        {
            title: "Короткий зміст (основні тези) документа",
            field: <TextAreaField
                index={''}
                id={'shortContent'}
                name={'shortContent'}
                title={"".toUpperCase()}
                value={shortContent}
                onChange={(e) => setShortContent(e.target.value)}
                placeholder={"Короткий зміст"}
                class={"form-control mb-3 rounded-0 border-0 p-1 border-bottom"}
                typeSize={'full'}
            />
        },
        {
            title: "Фактологічне викладення",
            field: <div className={'mb-3'}>
                <ReactQuill
                    ref={quillRef}
                    theme="snow"
                    modules={modules}
                    value={content}
                    style={{minHeight: '200px'}}
                    onChange={handleContentChange}
                />
            </div>
        },
        {
            title: "Висновки",
            field: <TextAreaField
                index={''}
                id={'summary'}
                name={'summary'}
                title={"".toUpperCase()}
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
                placeholder={"Висновки"}
                class={"form-control rounded-0 border-0 p-1 border-bottom"}
                typeSize={'full'}
            />
        }
    ];

    // CLEAR
    const clearContent = () => {
        // setFileName('')
        setContent(props.init)
    }

    let fileName = 'fact-file_' + Math.random().toString(36).substring(2, 10);

    async function generateDocument() {

        const htmlContent = `
          <h3 style="text-align: center;">${title}</h3>
          <br>   
          <table style="width: 100%;">
            <tr style="width: 100%; background: #b8bbbf; text-align: center;">
                 <td style="text-align: center;">
                    <h3>
                        <b>Ключові слова</b>
                    </h3>
                </td>
            </tr>
            <tr>
                <td><p>${keyWords.map((item) => item).join(", ")}</p></td>
            </tr>
            <tr style="width: 100%; background: #b8bbbf; text-align: center;">
                 <td style="text-align: center;">
                     <h3>
                         <b>Короткий зміст (основні тези) документа</b>
                     </h3>
                 </td>
            </tr>
            <tr><td>${shortContent}</td></tr>
             <tr style="width: 100%; background: #b8bbbf; text-align: center;">
                 <td style="text-align: center;">
                     <h3>
                         <b>Фактологічне викладення</b>
                     </h3>
                 </td>
            </tr>
            <tr><td>${content}</td></tr>
            <tr style="width: 100%; background: #b8bbbf;">
               <td style="text-align: center;">
                    <h3>
                        <b>Висновки</b>
                    </h3>
                </td>
            </tr>
            <tr>
                <td>
                    ${summary}
                </td>
            </tr>
          </table>
      `;

        // <h5 class="fw-bold vw-100" sclassName"background: #b8bbbf; text-align: center;">Ключові слова</h5>
        // <p>${keyWords.map((item) => item).join(", ")}</p>
        //
        // <h5 class="fw-bold" style="bclassNameound: #b8bbbf; text-align: center;">Короткий зміст (основні тези)
        //     документа</h5>
        // <p>${shortContent}</p>
        //
        // <h5 class="fw-bold" style="bclassNameound: #b8bbbf; text-align: center;">Фактологічне викладення</h5>
        // <p>${content}</p>
        //
        // <h5 class="fw-bold" style="bclassNameound: #b8bbbf; text-align: center;">Висновки</h5>
        // <p>${summary}</p>
        //
        // <br>

        try {
            const result = await HtmlToDocx(htmlContent, "<p>Document Header</p>", {
                pageSize: {
                    width: 12240,
                    height: 15840
                },
                margins: {
                    top: 1440,
                    right: 1800,
                    bottom: 1440,
                    left: 1800
                },
                tableOptions: {
                    // Add default cell padding (values are in twips)
                    // 144 twips is roughly 10px / 7.2pt
                    cellMargin: {
                        top: 144,
                        bottom: 144,
                        left: 144,
                        right: 144
                    }
                },
                title: title,
                creator: 'Docx App',
                pageNumber: true,
                footer: true
            }, `<div class="d-flex justify-content-between"><small>verify: ${fileName} #</small></div>`);

            // Convert result to Blob for download
            let blob;
            if (result instanceof Blob) {
                blob = result;
            } else if (result instanceof ArrayBuffer || result instanceof Uint8Array) {
                blob = new Blob([result], {
                    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                });
            }

            // Trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName + '.docx';
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating DOCX:', error);
        }
    }

    return <div id={'page'} className={'container min-vh-100'}>

        <br/>

        <div className="d-flex flex-wrap align-items-center justify-content-between position-fixed-">

            <div id="btn-back">
                <Link to={'/projects'} className={'btn btn-outline-dark rounded-0'}> <ArrowLeft/> Назад </Link>
            </div>

            <div id={'title-page'}>
                <h3>
                    Фактологічне викладення
                </h3>
            </div>

            <div id="download">
                <button
                    onClick={generateDocument}
                    className={'btn btn-primary rounded-0 rounded-bottom-3-rounded-top-0'}><Download/> *.docx
                </button>
            </div>
        </div>

        <hr/>

        <div className={'col-md-7 col-12 m-auto'}>
            <div className={'text-center'}>
                <input type="text"
                       placeholder={"введіть тему"}
                       value={title}
                       onChange={(e) => setTitle(e.target.value)}
                       className={'form-control rounded-0 text-uppercase text-center border-0 fw-bold'}
                />
            </div>

            <br/>
            {
                fields.map((field, i) => <div>
                    <div className={'text-center'}>
                        <h6 className={'bg-secondary-subtle p-1 fw-bold'}>
                            {field.title}
                        </h6>
                    </div>
                    <div>
                        {field.field}
                    </div>
                </div>)
            }
        </div>
    </div>

}

export default Fact_Profile_V1;
